<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.addPecToInstitution') }} 
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form>
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="etablissement-group"
                                        :label="$t('message.nomEtablissement')"
                                        label-for="etablissement"
                                >
                                    <select id="etablissement" v-model="$v.form.etablissement_id.$model"
                                            @change="clearErrorField('etablissement_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nomPatient-group"
                                        :label="$t('message.nomPatient')"
                                        label-for="nomPatient"
                                >
                                    <select id="nomPatient" v-model="$v.form.patient_id.$model"
                                            @change="clearErrorField('patient_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mPatients" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.patient_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('patient_id')" style="color:red">
                                    {{getErrorsField('patient_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <span class="obligatoire">*</span>
                                <b-form-group
                                        id="dateFacturation-group"
                                        :label="$t('message.dateactivity')"
                                        label-for="dateFacturation">
                                    <b-form-input
                                            id="dateFacturation"
                                            v-model="$v.form.date_cloture_activite.$model"
                                            :state="$v.form.date_cloture_activite.$dirty ? !(errorshasField('date_cloture_activite') || $v.form.date_cloture_activite.$error) : null"
                                            placeholder=""
                                            type="date"
                                            @focus="clearErrorField('date_cloture_activite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('date_cloture_activite')">
                                        {{ getErrorsField('date_cloture_activite') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.date_cloture_activite.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        

                        <b-row class="justify-content-center">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.enregistreractivity') }}
                            </b-button>
                        </b-row>
                    </b-container>


                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import {required} from "vuelidate/lib/validators";
    import SlimSelect from "slim-select";
    import moment from "moment";


    export default {
        name: "Add",
        computed: {
            ...mapGetters(['hasAdminRole', "userInstitutions","errors",
                'hasGestionnaireRole', 'hasMedecinControleRole','isComptable','hasAssistante','amaActivites']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },

            mPatients:function(){
                let pArray = [];
                if (_.isNull(this.form.etablissement_id)){
                    return [];
                }else{
                    let self = this;
                    let etablissement = _.find(self.userInstitutions,function (institution) {
                        return institution.id == self.form.etablissement_id;
                    });

                    let patients = etablissement.patients;
                    pArray = [];
                    _.forEach(patients , function (patient) {
                        let id = patient.user_id;
                        let nom =patient.user.nom + ' ' + (_.isNull(patient.user.prenom) ? '' :patient.user.prenom);

                        if (_.isUndefined(_.find(pArray, function (p) {
                            return p.id == id;
                        }))){
                            pArray.push({nom:nom,id:id});
                        }
                    })
                    return  pArray;
                }
            },

            mInstitutions:function () {
                let iArray = [];
                _.forEach(this.userInstitutions, function (institution) {
                    iArray.push({nom:institution.name, id:institution.id});
                })
                return iArray;
            }
        },

        data(){
            return {
                 missions: [],
                 selected: null,
                 content: "",
                form : {
                    patient_id:null,
                    etablissement_id:null,
                    date_cloture_activite: moment((new Date())).format('YYYY-MM-DD'),
                }
            }
        },
        methods:{
            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            validerForm(evt){
                evt.preventDefault();

                this.$v.form.$touch();

                if(!this.$v.form.$invalid) {
                    this.continuer = true;
                }
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        patient_id:this.form.patient_id,
                        etablissement_id:this.form.etablissement_id,
                        date_cloture:this.form.date_cloture_activite,
                    };

                    let successMessage = this.$i18n.t('message.AssignCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createPec', { args, errorMessages, successMessage })
                }
            },


            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },
        },

        validations() {
            return {

                form : {
                    patient_id: {required},
                    etablissement_id:{required},
                    date_cloture_activite:{required},
                },
            }
        },
        mounted() {
            this.getUserInstitutions();

            new SlimSelect({
                select: '#etablissement',
                placeholder: 'Select etablissement',
                limit: 1
            });

            new SlimSelect({
                select: '#nomPatient',
                placeholder: 'Select patient',
                limit: 1
            });
            
        }
    }
</script>

<style scoped>
    @import "~slim-select/dist/slimselect.min.css";
</style>
